import $ from 'jquery';
import { event } from 'linksoft';
import { dispatchAction } from 'linksoft';
import actions from './charts/actions';

export default function () {
    $('#coordinatesGrid').each(function () {
        // inline edit / coordinatesGrid
        event.off('linksoft.datatables.changesSaved', handleChangesSaved);
        event.on('linksoft.datatables.changesSaved', handleChangesSaved);

        // delete action / coordinatesGrid
        event.off('siisel.datatable.updated.coordinatesGrid', handleChangesSaved);
        event.on('siisel.datatable.updated.coordinatesGrid', handleChangesSaved);
    });

    // new entities
    $(document).off('siisel.axisCoordinatesUpdated', handleChangesSaved);
    $(document).on('siisel.axisCoordinatesUpdated', handleChangesSaved);
}

function handleChangesSaved(data) {
    dispatchAction(actions.refreshData());
};


// WEBPACK FOOTER //
// ./App/components/modules/axisChartsRefresh.js